<template>
  <div id="app">
    <div class="top_head">
      <div class="head-logo"><router-link to="/"><img src="./assets/img/ty_wm.png"></router-link> </div>
      <div class="head-menu">
      <nav class="pc-menu">
      <router-link to="/">{{ $t('二维码') }}</router-link>
      <span> | </span>
      <router-link to="/txm">{{ $t('条形码') }}</router-link> 
      <span> | </span>
      <router-link to="/img">{{ $t('图片(压缩/水印)') }}</router-link> 
      <span> | </span>
      <router-link to="/json">{{ $t('JSON格式化') }}</router-link> 
      <!-- <span> | </span>
      <router-link to="/excel">{{ $t('Excel处理') }}</router-link>
      <span> | </span>
      <router-link to="/test3">测试</router-link>  -->
      <!-- <span> | </span>
      <router-link to="/javaFormarts">toJava</router-link> -->

      
    </nav>
      </div>
    </div>
    <div class="top_head_kb">
      .
    </div>
    <nav class="mobile-menu">
      <router-link to="/">{{ $t('二维码') }}</router-link>
      <span> | </span>
      <router-link to="/txm">{{ $t('条形码') }}</router-link> 
      <span> | </span>
      <router-link to="/img">{{ $t('图片(压缩/水印)') }}</router-link> 
      <span> | </span>
      <router-link to="/json">{{ $t('JSON格式化') }}</router-link> 
    <span> | </span>
      <router-link to="/excel">{{ $t('Excel处理') }}</router-link>
    </nav>
    


    <router-view/>
  </div>
</template>
<script>
export default {
  methods: {
    changeLocale(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('locale', lang); // 保存语言偏好
    }
  }
}
</script>
<style lang="less">

@import '@/assets/less/app.less';
</style>
